
import { defineComponent } from 'vue'
import { bytesToSize } from '@remote/utils'
import { store } from '@remote/store'
import { usePathSelector } from '@remote/store/hezi-file/path-selector'
import { useDisk } from '@remote/store/hezi-file/disk'
import { safeJSONParse } from '@shared/utils'

export default defineComponent({
  name: 'DownloadPath',
  props: {
    id: {
      type: String,
      default: '',
    },
    hideSize: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup () {
    const { toggleVisibleSelectFolder, selectedPath, checkFileExit } = usePathSelector()

    return {
      store,
      toggleVisibleSelectFolder,
      selectedPath,
      checkFileExit,
      diskStore: useDisk(),
    }
  },
  data () {
    return {
      lastPath: null,
      netWorkState: true,
    }
  },
  computed: {
    diskSize () {
      return this.selectedPath.value.size
    },
    diskLeftSize () {
      return this.selectedPath.value.free
    },
    belowMinimum () {
      return this.selectedPath.value.free <= 10 * 1024
    },
    shortDownloadPath (): string {
      if (!this.netWorkState) return '网络异常'
      if (this.isDeviceOffline) return '设备离线'
      if (!this.selectedPath && !this.lastPath || !this.selectedPath.value.path) return '磁盘异常'

      const showPath = this.lastPath?.displayPath || this.selectedPath.value?.displayPath

      let separator = showPath?.includes(' > ') ? ' > ' : '/'
      let pathArr = showPath.split(separator)

      if (pathArr.length <= 3) pathArr = pathArr.map((item) => {
        return item.length > 5 ? `${item.substring(0, 4)}...` : item
      })

      if (pathArr.length > 3) {
        return [
          pathArr[0],
          pathArr[1],
          '...',
          pathArr[pathArr.length - 1],
        ].join(separator)
      }
      console.log('showPath 2', showPath)
      return showPath
    },
    isDeviceOffline () {
      return !this.store.state.status && this.store.state.loading === 0
    },
    isDiskException () {
      return !this.store.state.status && this.store.state.loading === 0 || this.diskStore?.data?.diskException
    },
  },
  async mounted () {
    // 传入任务id，查询到当前任务id在任务列表中已存在则禁止切换下载位置
    const task = this.store?.state.all[this.id]
    if (this.id && this.store?.state.tasks.includes(this.id) && task) {
      const extData = safeJSONParse(task.ext_data) as { dir: string }
      this.lastPath = await this.checkFileExit(extData.dir)
    } else {
      this.checkFileExit()
    }
    window.addEventListener('offline', this.onListenerNetWrok)
    window.addEventListener('online', this.onListenerNetWrok)
  },
  unmounted () {
    window.removeEventListener('offline', this.onListenerNetWrok)
    window.removeEventListener('online', this.onListenerNetWrok)
  },
  methods: {
    async showVisiblePathChoose () {
      this.toggleVisibleSelectFolder(true)
    },
    bytesToSize,
    onListenerNetWrok () {
      this.netWorkState = navigator.onLine
    },
  },
})
